<template>
  <div>
    <b-tabs card vertical>
      <b-tab v-for="(item, index) in layouts" :key="index" :title="item.tipo + ' - ' + item.subject">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(() => saveLayout(item))">
            <LayoutEmail :layout="item" />
          </form>
        </ValidationObserver>
      </b-tab>

      <!-- <b-tab title="Bienvenida Staff" active @click="getLayout(1)">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(saveLayout)">
            <LayoutEmail :layout="layout" @id="deleteFile" />
          </form>
        </ValidationObserver>
      </b-tab>
      <b-tab title="Bienvenida Cliente Administrador" @click="getLayout(2)">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(saveLayout)">
            <LayoutEmail :layout="layout" @id="deleteFile" />
          </form>
        </ValidationObserver>
      </b-tab>
      <b-tab title="Bienvenida Cliente Usuario" @click="getLayout(3)">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(saveLayout)">
            <LayoutEmail :layout="layout" @id="deleteFile" />
          </form>
        </ValidationObserver>
      </b-tab>
      <b-tab title="Verificación de cuenta" @click="getLayout(4)">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(saveLayout)">
            <LayoutEmail :layout="layout" @id="deleteFile" />
          </form>
        </ValidationObserver>
      </b-tab>
      <b-tab title="Reestablecer contraseña" @click="getLayout(5)">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(saveLayout)">
            <LayoutEmail :layout="layout" @id="deleteFile" />
          </form>
        </ValidationObserver>
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
import LayoutEmail from "src/views/staff/settings/LayoutEmail.vue";

export default {
  components: {
    LayoutEmail,
  },

  props: {
    layouts: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {};
  },

  methods: {
    async getLayout(id) {
      this.$emit("getLayout", id);
    },

    async deleteFile(id) {
      this.$emit("deleteFile", id);
    },

    saveLayout(layout) {
      this.$emit("saveLayout", layout);
    },
  },
};
</script>

<style scoped></style>
